import React from "react";

export function AT_DF_AccountStatus({member,value}) {

    return <div className="line-clamp-1">
        {value}
    </div>
}